import React, { useEffect, useState, useRef } from "react";
import { Table, Input, Button, Space, Modal } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import axios from "axios";
import "./add_edit_list_item.css";
import useSWR from "swr";


interface StockItem {
    item_code: string;
    item_name: string;
    qty: string;
    location_code_rack: string;
    location: string;
    uom: string;
    warehouse?: string;
}

const AdjustmentADDEDITITEMLIST: React.FC<{ warehouse: string, onSelect: (item: any) => void }> = ({ warehouse, onSelect }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortField, setSortField] = useState<string | undefined>(undefined);
    const [sortOrder, setSortOrder] = useState<string | undefined>(undefined);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<any>(null);
    const fetcher = (url: string) => axios.get(url).then(res => res.data);
    const { data, isValidating, error } = useSWR(
        warehouse
            ? `${process.env.REACT_APP_BACKEND_URL}/api/adjustment/stock-items?warehouse=${warehouse}&page=${currentPage}&pageSize=${pageSize}&search=${searchText}&sortBy=${sortField || ''}&sortOrder=${sortOrder || ''}`
            : null,
        fetcher
    );

    useEffect(() => {
        if (data) console.log("✅ Data Berhasil Tampil:", data.data);
        if (error) console.error("❌ Data Gagal Tampil:", error);
    }, [data, error]);

    const handleSearch = (selectedKeys: string[], confirm: any, dataIndex: any) => {
        confirm();
        setSearchText(selectedKeys[0] || '');
        setSearchedColumn(dataIndex);
        setCurrentPage(1);
    };

    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
        setSearchedColumn('');
        setCurrentPage(1);
    };

    const getColumnSearchProps = (dataIndex: keyof StockItem): any => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }: any) => (
            <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => close()}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
        ),
        filterDropdownProps: {
            onOpenChange(open: boolean) {
                if (open) {
                    setTimeout(() => searchInput.current?.select(), 100);
                }
            },
        },
        render: (text: any) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const handleTableChange = (pagination: any, filters: any, sorter: any) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
        if (sorter && sorter.field) {
            setSortField(sorter.field);
            setSortOrder(sorter.order);
        } else {
            setSortField(undefined);
            setSortOrder(undefined);
        }
    };

    const handleRowDoubleClick = (record: StockItem) => {
        if (!record.location || !record.warehouse || record.warehouse !== warehouse) {
            Modal.warning({
                title: "Informasi",
                content: "item part ini belum ada di lokasi gudang {no_query_db_sp_stocks}",
            });
            return;
        }
        onSelect(record);
    };

    const columns = [
        { title: 'Item Code', dataIndex: 'item_code', key: 'item_code', sorter: true, ...getColumnSearchProps('item_code') },
        { title: 'Item Name', dataIndex: 'item_name', key: 'item_name', sorter: true, ...getColumnSearchProps('item_name') },
        { title: 'Qty', dataIndex: 'qty', key: 'qty', sorter: true },
        { title: 'Location', dataIndex: 'location', key: 'location', sorter: true }
    ];
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    return (

        <div id="ia31" style={transformStyle}>
            <div className="gjs-grid-row" id="ik2yc">
                <div className="gjs-grid-column" id="iyg4w">
                    <Table
                        rowKey={(record: StockItem) => `${record.item_code}-${record.location}`}
                        dataSource={data?.data || []}
                        columns={columns}
                        loading={!data && !error && isValidating}
                        pagination={{ current: currentPage, pageSize: pageSize, total: data?.total || 0, showSizeChanger: true }}
                        onChange={handleTableChange}
                        onRow={(record) => ({ onDoubleClick: () => handleRowDoubleClick(record) })}
                    />
                </div>
            </div>
        </div>
    );
};

export default AdjustmentADDEDITITEMLIST;